<template>
  <div class="fondo">
    <b-container>
      <br />
      <br />
      <b-row>
        <b-col md="3"></b-col>
        <b-col md="6">
          <b-form center @submit="onSubmit" style="background: transparent">
            <b-card>
              <div class="row">
                <div class="col-sm-4"></div>
                <div class="col-sm-4">
                  <img width="100%" src="../assets/logo.png" />
                </div>
                <div class="col-sm-4"></div>
              </div>
              <br />

              <h3 style="text-align: center" >Acceso a la plataforma</h3>

              <br />
              <!-- Using props -->
              <b-input-group size="lg" prepend="Correo">
                <b-form-input type="email" v-model="email"></b-form-input>
              </b-input-group>
              <br />

              <b-input-group size="lg" prepend="Clave">
                <b-form-input type="password" v-model="password"></b-form-input>
              </b-input-group>

              <br />

              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                  <b-button block pill class="btn-card-color" type="submit"
                    >Acceder</b-button
                  >
                  <br />
                  <b-row>
                    <b-col md="5"></b-col>
                    <b-col md="2">
                      <b-spinner
                        variant="primary"
                        v-show="progress"
                        label="Text Centered"
                      ></b-spinner>
                    </b-col>
                    <b-col md="5"></b-col>
                  </b-row>

                  <!-- <router-link v-b-modal.modal-register :to="{}"
                    >¿No tienes cuenta?, Registrate</router-link
                  > -->
                  <br />
                  <br />
                </div>
                <div class="col-md-1"></div>
              </div>
            </b-card>
          </b-form>
        </b-col>
        <b-col md="3"></b-col>
      </b-row>

      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </b-container>

  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions } from "vuex";
//import Permission from "../../permission";
export default {
  name: "Login",
  components: {},
  data() {
    return {
      progress: false,
      progress1: false,
      btnLogin: false,
      name: "",
      last_name: "",
      email: "",
      email1: "",
      country: "",
      state: "",
      phone: "",
      password: "",
      password1: "",
      password2: null,
      RecoveryEmail: null,
      NameState: null,
      listRoles: [],
      auth: {},
      countries: [],
      countryTmp: [],
      states: [],
      stateTmp: [],
    };
  },
  computed: {
    
  },
  mounted() {
    
  },
  methods: {
    ...mapActions([
      "login",
      "recoveryPass",
      "RegisterUser",
      "AllCountry",
      "AllStates",
    ]),
    onSubmit(evt) {
      evt.preventDefault();
      console.log("Submit");
      if (this.email == "" || this.password == "") {
        Swal.fire({
          title: "Completa los campos",
          text: "Por favor ingresa un correo y una clave",
          icon: "warning",
        });
      } else {
        this.progress = true;
        this.btnLogin = true;
        this.login({
          email: this.email,
          password: this.password,
        })
          .then((data) => {
            console.log("LOGIN 200");
            console.log(data);
            if (data.code == 200) {
              this.btnLogin = false;
              if (data.data.role_id !== 1) {
                this.progress = false;
                Swal.fire({
                title: "No autorizado",
                text: "Tu cuenta no tiene privilegios para acceder aqui.",
                icon: "error",
              }).then(() => {
                
              });
                return
              }
              this.$router.push("/admin/home");
              this.progress = false;

              const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
              Toast.fire({
                icon: "success",
                title: "¡Bienvenido!",
              });
            } else if (data.code == 404) {
              Swal.fire({
                title: "Correo no registrado",
                text: "Por favor comprueba los datos ingresados",
                icon: "warning",
              }).then((result2) => {
                console.log(result2);
              });
            } else if (data.code == 403) {
              Swal.fire({
                title: "Contraseña incorrecta",
                text: "Por favor comprueba los datos ingresados",
                icon: "warning",
              }).then((result2) => {
                console.log(result2);
              });
            }
          })

          .catch((data) => {
            this.btnLogin = false;
            if (
              data.message ==
              "There is no user registered with the email address you entered"
            ) {
              Swal.fire({
                title: "Correo no registrado",
                text: "Por favor comprueba los datos ingresados",
                icon: "warning",
              }).then((result2) => {
                console.log(result2);
              });
            } else if (data.message == "Invalid user password") {
              const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
              Toast.fire({
                icon: "warning",
                title: "Contraseña incorrecta",
              });
            } else if (
              data.message == "Your email needs to be verified first"
            ) {
              Swal.fire({
                title: "Correo no verificado",
                text:
                  "Por favor, verifica tu correo antes de volver a ingresar",
                icon: "warning",
              }).then((result2) => {
                console.log(result2);
              });
            } else if (
              data.message == "Your user is not active in the system"
            ) {
              Swal.fire({
                title: "Usuario Inhabilitado",
                text: "Se le ha inhabilitado el acceso a la plataforma",
                icon: "warning",
              }).then((result2) => {
                console.log(result2);
              });
            } else if (data.message == "Access forbidden. You must wait five minutes to login"){
              Swal.fire({
                title: "Acceso denegado",
                text: "Bloqueado por unos minutos debido a varios intentos errados de inicio de sesión",
                icon: "warning",
              });
            } else {
              Swal.fire({
                title: "Error del servidor",
                text: "Intente más tarde",
                icon: "warning",
              });
            }
            this.progress = false;
          });
      }
    },
    /* handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.onSubmitRegister();
    },
    resetModal() {
      this.RecoveryEmail = "";
      this.NameState = null;
      this.name = "";
      this.last_name = ""
      this.email1 = ""
      this.country = ""
      this.state = ""
      this.phone = ""
      this.password1 = ""
      this.password2 = null
    },
    getCountry() {
      this.AllCountry().then((response) => {
        if (response.code == 200) {
          this.countries = response.data;
          this.countries.forEach((element) => {
            this.countryTmp.push({
              value: element.name_en,
              text: element.name_en,
            });
          });
        }
      });
    },
    getState() {
      this.AllStates().then((response) => {
        if (response.code == 200) {
          this.states = response.data;
          this.states.forEach((element) => {
            this.stateTmp.push({
              value: element.state,
              text: element.state,
            });
          });
        }
      });
    },
    onSubmitRegister() {
      if (
        this.name == "" ||
        this.last_name == "" ||
        this.country == "" ||
        this.email1 == "" ||
        this.password1 == "" ||
        this.phone == ""
      ) {
        Swal.fire({
          title: "Completa los campos",
          text: "Por favor, completa todos los datos",
          icon: "warning",
        });
      } else {
        if (this.country == "Venezuela" && this.state == "") {
          Swal.fire({
            title: "Completa los campos",
            text: "Por favor, completa todos los datos",
            icon: "warning",
          });
        } else {
          if (this.password1 == this.password2) {
            this.progress1 = true;
            let form = {
              first_name: this.name,
              last_name: this.last_name,
              email: this.email1,
              country: this.country,
              state: this.state,
              password: this.password1,
              phone: this.phone
            };
            console.log(form);
            this.RegisterUser(form)
            .then((response) => {
              console.log(response.data);
              if (response.code == 200) {
                Swal.fire({
                  title: "Se ha enviado un correo de confirmación",
                  text:
                    "Por favor, revisa tu correo electrónico para confirmar tu cuenta",
                  icon: "success",
                });
                this.$nextTick(() => {
              this.$bvModal.hide("modal-register");
            });
                this.progress1 = false;
              } else if (response.code == 409) {
                Swal.fire({
                  title: "Ya existe un usuario con el email ingresado",
                  text: "Por favor, ingresa un correo valido",
                  icon: "warning",
                });
                this.progress1 = false;
              }
            })
            .catch((error) => {
              console.log(error);
              Swal.fire({
                title: "Correo ingresado no existe",
                text: "Por favor, ingresa un correo valido",
                icon: "error",
              });
              this.progress1 = false;
            });
          } else {
            Swal.fire({
              title: "Las contraseñas no coinciden",
              text: "Asegurese de que las contraseñas sean iguales",
              icon: "warning",
            });
          }
        }
      }
    }, */
  },
};
</script>

<style>
.fondo {
  background: linear-gradient(to right, #7b7b7b,#434343, #121419);
  position: relative;
  max-height: 100%;
  max-width: 100%;
  top: 0;

}

.fondo::before{
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #7b7b7b,#434343, #121419); /* Aquí ajusta el nivel de transparencia (0.5 en este caso) */
  z-index: -1; 
}
</style>